var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "table",
    { staticStyle: { width: "100%", "border-spacing": "0 !important" } },
    [
      _c("tr", [
        _c(
          "td",
          { staticClass: "providers-padding" },
          [
            _c(
              "v-layout",
              { attrs: { row: "", wrap: "" } },
              [
                _c(
                  "v-flex",
                  { staticClass: "pb-0", attrs: { xs9: "" } },
                  [
                    _c(
                      "v-tooltip",
                      { attrs: { disabled: !_vm.showTooltip, top: "" } },
                      [
                        _c(
                          "v-autocomplete",
                          {
                            attrs: {
                              slot: "activator",
                              label: "Add New Provider",
                              "return-object": true,
                              items: _vm.providersArray,
                              loading: _vm.providerSearchLoading,
                              "error-messages": _vm.providerSearchError,
                              "search-input": _vm.providerSearchInput,
                              "no-filter": true,
                              clearable: true
                            },
                            on: {
                              "update:searchInput": function($event) {
                                _vm.providerSearchInput = $event
                              },
                              "update:search-input": function($event) {
                                _vm.providerSearchInput = $event
                              },
                              focus: _vm.clearNewProviderAutoComplete
                            },
                            slot: "activator",
                            scopedSlots: _vm._u([
                              {
                                key: "item",
                                fn: function(ref) {
                                  var item = ref.item
                                  var tile = ref.tile
                                  return [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(item.firstName) +
                                        " " +
                                        _vm._s(item.lastName) +
                                        "\n                  "
                                    ),
                                    item.credentialType
                                      ? _c("span", [_vm._v("/")])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isMobile
                                      ? _c("span", [
                                          _vm._v(_vm._s(item.credentialType))
                                        ])
                                      : _c("span", [
                                          _vm._v(_vm._s(item.credentialName))
                                        ])
                                  ]
                                }
                              },
                              {
                                key: "selection",
                                fn: function(ref) {
                                  var item = ref.item
                                  var selected = ref.selected
                                  return [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(item.firstName) +
                                        " " +
                                        _vm._s(item.lastName) +
                                        "\n                  "
                                    ),
                                    item.credentialType
                                      ? _c("span", [_vm._v("/")])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isMobile
                                      ? _c("span", [
                                          _vm._v(_vm._s(item.credentialType))
                                        ])
                                      : _c("span", [
                                          _vm._v(_vm._s(item.credentialName))
                                        ])
                                  ]
                                }
                              }
                            ]),
                            model: {
                              value: _vm.newProvider,
                              callback: function($$v) {
                                _vm.newProvider = $$v
                              },
                              expression: "newProvider"
                            }
                          },
                          [
                            _vm._v(" "),
                            _vm._v(" "),
                            _c(
                              "template",
                              { slot: "no-data" },
                              [
                                _c(
                                  "v-list",
                                  [
                                    !_vm.providerSearchInput
                                      ? _c("v-list-tile", [
                                          _vm._v(
                                            "\n                      Please type a Provider.\n                    "
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.providerSearchInput &&
                                    !_vm.providerSearchLoading
                                      ? _c(
                                          "v-list-tile",
                                          { staticClass: "red--text" },
                                          [
                                            _vm._v(
                                              "\n                      No Results\n                    "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("span", [_vm._v("Select a provider to add")])
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("v-flex", { staticClass: "pb-0", attrs: { xs3: "" } }, [
                  _vm.isDesktop
                    ? _c(
                        "span",
                        [
                          _c(
                            "v-tooltip",
                            { attrs: { disabled: !_vm.showTooltip, top: "" } },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "green--text actionButton",
                                  staticStyle: { "margin-top": "15px" },
                                  attrs: {
                                    slot: "activator",
                                    small: "",
                                    round: ""
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.addNewProviderByStudent(null)
                                    }
                                  },
                                  slot: "activator"
                                },
                                [
                                  _c(
                                    "span",
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "icon-padding",
                                          attrs: { small: "" }
                                        },
                                        [_vm._v("mdi-account-plus")]
                                      ),
                                      _vm._v(" "),
                                      !_vm.isMobile
                                        ? _c("small", [_vm._v("Add Provider")])
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  "Add provider to student team and service"
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _c(
                        "span",
                        {
                          on: {
                            click: function($event) {
                              return _vm.addNewProviderByStudent(null)
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "green--text",
                              staticStyle: { "padding-top": "20px" }
                            },
                            [
                              _vm._v(
                                "\n              mdi-account-plus\n            "
                              )
                            ]
                          )
                        ],
                        1
                      )
                ])
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.service.providers.length
        ? _c("tr", [
            _c(
              "th",
              { staticClass: "providers-padding", attrs: { colspan: "2" } },
              [_vm._v("Manage Providers")]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.service.providers, function(provider, index) {
        return _vm.service.providers.length
          ? _c(
              "tr",
              { key: index, staticStyle: { "border-color": "transparent" } },
              [
                _c(
                  "td",
                  {
                    class: { "light-gray-bg": index % 2 == 0 },
                    staticStyle: {
                      width: "100%",
                      "padding-left": "36px",
                      "padding-right": "24px"
                    }
                  },
                  [
                    _c(
                      "v-layout",
                      {
                        attrs: {
                          row: "",
                          wrap: "",
                          "fill-height": "",
                          "align-center": ""
                        }
                      },
                      [
                        _c("v-flex", { attrs: { xs9: "" } }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                provider.providerFirstName +
                                  " " +
                                  provider.providerLastName
                              ) +
                              "\n            "
                          ),
                          _vm.isMobile && provider.credentialType
                            ? _c("span", [
                                _vm._v(
                                  "\n            / " +
                                    _vm._s(provider.credentialType) +
                                    "\n          "
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.isMobile && provider.credentialName
                            ? _c("span", [
                                _vm._v(
                                  "\n            / " +
                                    _vm._s(provider.credentialName) +
                                    "\n          "
                                )
                              ])
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("v-flex", { attrs: { xs3: "" } }, [
                          provider.addType
                            ? _c(
                                "span",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.addNewProviderByStudent(
                                        provider.providerUserId
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm.isMobile || _vm.isTablet
                                    ? _c(
                                        "span",
                                        { staticClass: "green--text" },
                                        [
                                          provider.addType === "TEAM"
                                            ? _c(
                                                "span",
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      staticClass: "green--text"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                            mdi-lock-plus\n                          "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    : _c(
                                        "span",
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass:
                                                "green--text actionButton",
                                              attrs: { small: "", round: "" }
                                            },
                                            [
                                              provider.addType === "TEAM"
                                                ? _c(
                                                    "span",
                                                    [
                                                      _c(
                                                        "v-tooltip",
                                                        {
                                                          attrs: {
                                                            disabled: !_vm.showTooltip,
                                                            top: ""
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              attrs: {
                                                                slot:
                                                                  "activator"
                                                              },
                                                              slot: "activator"
                                                            },
                                                            [
                                                              _c(
                                                                "v-icon",
                                                                {
                                                                  staticClass:
                                                                    "icon-padding",
                                                                  attrs: {
                                                                    small: ""
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                              mdi-lock-plus\n                            "
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c("small", [
                                                                _vm._v(
                                                                  "Add Team"
                                                                )
                                                              ])
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _c("span", [
                                                            _vm._v(
                                                              "Add provider to student team"
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          provider.removeType
                            ? _c(
                                "span",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.removeProviderByStudent(
                                        provider.providerId
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm.isMobile || _vm.isTablet
                                    ? _c("span", [
                                        provider.removeType === "TEAM"
                                          ? _c(
                                              "span",
                                              [
                                                _c(
                                                  "v-icon",
                                                  { staticClass: "red--text" },
                                                  [
                                                    _vm._v(
                                                      "\n                              mdi-lock-open\n                            "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        provider.removeType === "PROVIDER"
                                          ? _c(
                                              "span",
                                              [
                                                _c(
                                                  "v-icon",
                                                  { staticClass: "red--text" },
                                                  [
                                                    _vm._v(
                                                      "\n                            mdi-account-remove\n                          "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      ])
                                    : _c(
                                        "span",
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass: "actionButton",
                                              attrs: { small: "", round: "" }
                                            },
                                            [
                                              provider.removeType === "TEAM"
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass: "red--text"
                                                    },
                                                    [
                                                      _c(
                                                        "v-tooltip",
                                                        {
                                                          attrs: {
                                                            disabled: !_vm.showTooltip,
                                                            top: ""
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              attrs: {
                                                                slot:
                                                                  "activator"
                                                              },
                                                              slot: "activator"
                                                            },
                                                            [
                                                              _c(
                                                                "v-icon",
                                                                {
                                                                  staticStyle: {
                                                                    "padding-right":
                                                                      "10px"
                                                                  },
                                                                  attrs: {
                                                                    small: ""
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                  mdi-lock-open\n                                "
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "small",
                                                                {
                                                                  staticClass:
                                                                    "red--text"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Remove From Team"
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _c("span", [
                                                            _vm._v(
                                                              "Remove provider from student team"
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              provider.removeType === "PROVIDER"
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass: "red--text"
                                                    },
                                                    [
                                                      _c(
                                                        "v-tooltip",
                                                        {
                                                          attrs: {
                                                            disabled: !_vm.showTooltip,
                                                            top: ""
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              attrs: {
                                                                slot:
                                                                  "activator"
                                                              },
                                                              slot: "activator"
                                                            },
                                                            [
                                                              _c(
                                                                "v-icon",
                                                                {
                                                                  staticStyle: {
                                                                    "padding-right":
                                                                      "10px"
                                                                  },
                                                                  attrs: {
                                                                    small: ""
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                 mdi-account-remove\n                                "
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "small",
                                                                {
                                                                  staticClass:
                                                                    "red--text"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Remove Provider"
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _c("span", [
                                                            _vm._v(
                                                              "Remove provider from student team and service"
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !provider.removeType && !provider.addType
                            ? _c("span", [
                                !_vm.isMobile
                                  ? _c(
                                      "span",
                                      [
                                        _c("v-btn", {
                                          staticClass:
                                            "actionButton small round",
                                          staticStyle: {
                                            visibility: "hidden !important",
                                            margin: "0"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _c(
                                      "span",
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            staticStyle: {
                                              visibility: "hidden !important"
                                            }
                                          },
                                          [_vm._v("mdi-lock-plus")]
                                        )
                                      ],
                                      1
                                    )
                              ])
                            : _vm._e()
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            )
          : _vm._e()
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2dbfbe6e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2dbfbe6e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/agency-scheduler/add-by-student/add-new-provider-autocomplete.vue
// module id = null
// module chunks = 